import { Box, Grid } from "@mui/material";
import { ContentRendererContainer } from "./ContentRendererContainer";
import { ContentRendererCard } from "./ContentRendererCard";
import { CommonContainerPropsComponent } from "../../../api/content-client/service";

interface Props {
  containerProps?: CommonContainerPropsComponent;
  itemType?: "card" | "plain" | null;
  items?: Record<string, any>[];
  maxItemsPerRow?: "one" | "two" | "three" | "four" | null;
  isForAgreementGeneration?: boolean;
}

const gridItemWidthBy: Record<"one" | "two" | "three" | "four", number> = {
  one: 12,
  two: 6,
  three: 4,
  four: 3,
};

export function ContentRendererGridItems(block: Props) {
  const { containerProps, itemType, items, maxItemsPerRow, isForAgreementGeneration } = block || {};

  return (
    <ContentRendererContainer containerProps={containerProps} isForAgreementGeneration={isForAgreementGeneration}>
      <Box py={isForAgreementGeneration ? undefined : 5}>
        <Grid container spacing={3}>
          {itemType === "card"
            ? items?.map((block) => {
                return (
                  <ContentRendererCard
                    key={block.id}
                    gridWidth={gridItemWidthBy[maxItemsPerRow || "three"]}
                    {...block}
                    isForAgreementGeneration={isForAgreementGeneration}
                    isGridItem
                  />
                );
              })
            : null}
        </Grid>
      </Box>
    </ContentRendererContainer>
  );
}
